import $ from 'jquery';
import Tabby from 'tabbyjs';

// See: https://github.com/cferdinaGndi/tabby

$('.js-tabs').each((index, tabs) => {
  const $tabs = $(tabs);
  const uniqueClass = `js-tabs-${index}`;
  $tabs.addClass(uniqueClass);
  const tabby = new Tabby(`.${uniqueClass}`, {
    default: `.js-tabs-default`,
  });
});

$(document).on('tabby', function (event) {
  const $content = $(event.detail.content);
  const $flickity = $content.find('.js-flickity');
  if ($flickity.length >= 1) {
    $flickity.flickity('resize');
  }
});
